import React from "react";
import PropTypes from "prop-types";
import "./FormButtons.scss"; 

const FormButtons = ({
  isSubmitting,
  handleSave,
  handleCancel,
  saveText = "Guardar",
  cancelText = "Cancelar",
  isSaveDisabled = false,
  showSaveButton = true, 
}) => {
  return (
    <div className="btn-form-state">
      {showSaveButton && (
        <button
          type="button"
          onClick={handleSave}
          disabled={isSubmitting || isSaveDisabled}
          className={`save-button ${isSaveDisabled ? "disabled" : ""}`}
        >
          {isSubmitting ? "Guardando..." : saveText}
        </button>
      )}

      <button
        type="button"
        onClick={handleCancel}
        className="cancel-button"
        disabled={isSubmitting}
      >
        {cancelText}
      </button>
    </div>
  );
};

FormButtons.propTypes = {
  isSubmitting: PropTypes.bool,
  handleSave: PropTypes.func,
  handleCancel: PropTypes.func.isRequired,
  saveText: PropTypes.string,
  cancelText: PropTypes.string,
  isSaveDisabled: PropTypes.bool,
  showSaveButton: PropTypes.bool, 
};

export default FormButtons;
